import tw from 'tailwind.macro'
import { css } from 'styled-components'

export const hidden = css`
  ${tw`hidden xl:block`};
`
